import { render, staticRenderFns } from "./login-privacy.vue?vue&type=template&id=4e4a39fc&scoped=true"
import script from "./login-privacy.vue?vue&type=script&lang=ts"
export * from "./login-privacy.vue?vue&type=script&lang=ts"
import style0 from "./login-privacy.vue?vue&type=style&index=0&id=4e4a39fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4a39fc",
  null
  
)

export default component.exports